import axios from 'axios';
import LogRocket from 'logrocket';

import { logout, userInformation } from '@redux/actions/User';
import { FurtherUserErrorCode } from 'further-types/further-user';

const getLocalhostAdjustedBaseUrl = () => {
  const configured = process.env.REACT_APP_BASEURL;
  if (typeof configured !== 'string' || !configured.length) return configured;

  const hostname = window.location.hostname;
  const isLocalhostHost =
    hostname === 'localhost' || hostname.endsWith('.localhost');
  if (!isLocalhostHost) return configured;

  try {
    const url = new URL(configured);
    const port = url.port || '4500';
    return `http://${hostname}:${port}/api/v1`;
  } catch {
    return configured;
  }
};

const axiosUtil = {
  initalise: (store) => {
    axios.defaults.baseURL = getLocalhostAdjustedBaseUrl();
    axios.defaults.withCredentials = true;
    axios.interceptors.request.use(
      (axiosConfig) => {
        axiosConfig.headers['Content-Type'] = 'application/json';

        if (LogRocket.sessionURL) {
          axiosConfig.headers['x-logrocket-url'] = LogRocket.sessionURL;
        }

        return axiosConfig;
      },
      (error) => {
        Promise.reject(error);
      },
    );
    // Response Interceptor - logout the user if the api sends a request to do that
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      function (error) {
        if (
          error?.response?.status === 403 &&
          error?.response?.data?.error?.code ===
            FurtherUserErrorCode.ImpersonationFirmMismatch
        ) {
          store.dispatch(userInformation(null));
          return Promise.reject(error);
        }
        if (error?.response?.data?.is_logout === 1) {
          store.dispatch(logout({ queryClient: undefined }));
        }
        return Promise.reject(error);
      },
    );
  },
};

export default axiosUtil;
